/**
 * 自定义指令：v-date-range-instant
 * 功能：在 el-date-picker (type="daterange") 中，点击开始日期时立即显示在输入框中
 * 
 * 使用方式：
 * <el-date-picker v-date-range-instant type="daterange" ... />
 */

export default {
  /**
   * inserted 钩子在被绑定的元素插入到父节点时调用。 
   * 此时父节点已存在
   * 但不保证元素已被插入到最终的 document 中
   */
  inserted(el, binding, vnode) {
    // 获取 el-date-picker 组件实例
    const picker = el.__vue__ || vnode.componentInstance

    if (!picker) {
      console.warn('[v-date-range-instant] 无法获取组件实例')
      return
    }

    let unwatchMinDate = null

    // 用户点击开始日期时的回调函数
    function onStartDateClick(startDate) {
      // 从组件 props 获取日期格式，默认 yyyy-MM-dd
      const valueFormat = picker.valueFormat || 'yyyy-MM-dd'
      
      // 根据组件的 valueFormat 格式化日期
      const formatDate = (date, format) => {
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        return format
          .replace('yyyy', year)
          .replace('MM', month)
          .replace('dd', day)
      }
      
      // 获取开始日期和结束日期输入框
      const inputs = el.querySelectorAll('.el-range-input')
      const startInput = inputs[0]
      const endInput = inputs[1]
      
      // 清空两个输入框
      if (startInput) startInput.value = ''
      if (endInput) endInput.value = ''
      
      // 赋值开始日期
      if (startInput) {
        startInput.value = formatDate(startDate, valueFormat)
      }
    }

    // 设置 minDate 监听器
    function setupMinDateWatcher() {
      if (unwatchMinDate) return // 已设置过，跳过
      
      // 通过 DOM 查找日期范围面板组件
      const panelEl = document.querySelector('.el-date-range-picker')
      if (!panelEl || !panelEl.__vue__) return
      
      // 面板组件在 __vue__.$parent 上
      const panel = panelEl.__vue__.$parent
      if (!panel || !('minDate' in panel)) return
      
      unwatchMinDate = panel.$watch('minDate', (newVal, oldVal) => {
        // 当 minDate 被设置且正在选择范围时，说明用户刚点击了开始日期
        if (newVal && panel.rangeState && panel.rangeState.selecting) {
          onStartDateClick(newVal)
        }
      })
      el.__dateRangeInstant_unwatchMinDate = unwatchMinDate
    }

    // 监听面板打开，首次打开时设置 minDate 监听器
    picker.$watch('pickerVisible', (visible) => {
      if (visible) {
        picker.$nextTick(() => {
          setupMinDateWatcher()
        })
      }
    })

  },

  /**
   * unbind 钩子在指令与元素解绑时调用，通常发生在：
   * 元素从 DOM 中移除时（如 v-if="false" 导致元素销毁）
   * 组件销毁时（父组件被销毁，子元素随之销毁）
   * 路由切换时（当前页面组件被销毁）
   */
  unbind(el) {
    // 清理 minDate 监听器
    if (el.__dateRangeInstant_unwatchMinDate) {
      el.__dateRangeInstant_unwatchMinDate()
      delete el.__dateRangeInstant_unwatchMinDate
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/dateRangeInstant.js